import { FC } from 'react';

import { usePartnerDividends } from '../context/PartnerDividendsContext';

import DividendsTableHeader from './DividendsTableHeader';
import DividendsTableBody from './DividendsTableBody';
import DividendsTableFooter from './DividendsTableFooter';

const DividendsTable: FC = () => {
  const { data } = usePartnerDividends();

  const hasData = data.dividends?.length > 0;

  return (
    <table
      className={`table table-striped ${
        data.isSummaryView ? 'table-font-sm' : ''
      }`}
    >
      <DividendsTableHeader />

      <DividendsTableBody />

      {hasData && <DividendsTableFooter />}
    </table>
  );
};

export default DividendsTable;
